// extracted by mini-css-extract-plugin
export default {"box1":"previewState_box1__x6Gyc","box2":"previewState_box2__gLEks","box3":"previewState_box3__Kw6uz"};